import React, { useEffect, useState } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required chart elements with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export default function ColumnLineChart({ years = [], selectedGlobalYear  }) {
  const [chartData, setChartData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(selectedGlobalYear || new Date().getFullYear());

  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }
  const [currency, setCurrency] = useState("");

  useEffect(() => {
  setSelectedYear(selectedGlobalYear); // Sync with global year when it changes
}, [selectedGlobalYear]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      }
    };

    fetchCurrencyData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetYearlyExpenseChart?groupId=${groupId}&year=${selectedYear}`
        );
        const data = await response.json();
        setChartData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear]);

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[parseInt(monthNumber, 10) - 1];
  };

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value, 10));
  };

  // Chart.js data configuration
  const data = {
    labels: chartData.map((item) => getMonthName(item.month)),
    datasets: [
      {
        label: "Total Credit",
        borderColor: "rgba(255,0,0,0.7)", // Line color for Total Credit
        backgroundColor: "rgba(255,0,0,0.7)",
        data: chartData.map((item) => item.totalDebit),
        fill: false,
        tension: 0.3, // To smooth the line
        borderWidth: 2, // Set line thickness (make it thinner, e.g., 2px)
        pointRadius: 3,
      },
      {
        label: "Total Debit",
        borderColor: "limegreen", // Line color for Total Debit
        backgroundColor: "limegreen",
        data: chartData.map((item) => item.totalCredit),
        fill: false,
        tension: 0.3, // To smooth the line
        borderWidth: 2, // Set line thickness (make it thinner, e.g., 2px)
        pointRadius: 3,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    title: {
      display: false,
      text: "Orders Chart",
    },
    tooltips: {
      mode: "index",
      intersect: false,
    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    legend: {
      labels: {
        fontColor: "rgba(0,0,0,.4)",
      },
      align: "end",
      position: "bottom",
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Month",
        },
        grid: {
          borderDash: [2],
          borderDashOffset: [2],
          color: "rgba(33, 37, 41, 0.3)",
          zeroLineColor: "rgba(33, 37, 41, 0.3)",
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: "Total Expense",
        },
        grid: {
          borderDash: [2],
          drawBorder: true,
          borderDashOffset: [2],
          color: "rgba(33, 37, 41, 0.2)",
          zeroLineColor: "rgba(33, 37, 41, 0.15)",
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
        },
      },
    },
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex items-center justify-between">
            <h2
              className="text-blueGray-700 text-xl font-semibold"
              style={{ fontSize: "1rem" }}
            >
              Yearly Category Wise Expenses ({currency})
            </h2>
                     <select
              className="bg-white text-black border border-gray-400 rounded px-3 py-1 w-32"
              value={selectedYear}
              onChange={handleYearChange}
            >
              {years.map((yr) => (
                <option key={yr} value={yr}>
                  {yr}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-350-px">
            {/* Use the Line component from react-chartjs-2 */}
            <Line data={data} options={options} />
          </div>
        </div>
      </div>
    </>
  );
}
